import React, { useRef } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { storeFormAction, userFormAction } from "../../redux/rootReducer";
import { getUsersForSubscriptionSagaAction, saveGoodsPurchaseSagaAction } from "../../redux/sagaActions";
import { STORE_FORM_INITIAL, USER_FORM_INITIAL } from "../../redux/initialStateConstant";
import Payment from "../Payment/Payment";
import Checkbox from "../Checkbox/Checkbox";

const StoreForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const storeForm = useSelector(state => state.storeForm);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        if (!text.trim()) {
            dispatch(storeFormAction({
                ...storeForm,
                user: { id: '', name: '', sum: '', subscriptions: '' },
                users: [],
                userInput: ''
            }));
            return false;
        }

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'storeForm' }));
        }, 500);
    };

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                            onClick={ () => dispatch(storeFormAction(STORE_FORM_INITIAL)) }
                        />
                        <div className="form__title">{ storeForm.goods_name }</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Посетитель (почта или телефон)</div>
                        <div className="dropdown">
                            <input type="text" className="input"
                                   value={
                                       storeForm.user?.name ||
                                       storeForm.userInput || ''
                                   }
                                   onInput={ event => {
                                       dispatch(storeFormAction({
                                           ...storeForm,
                                           userInput: event.target.value,
                                           user: { id: '', name: '', sum: '', subscriptions: '' },
                                       }));
                                       // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                       getUsers(event.target.value);
                                   } }
                            />
                            <div className={ `dropdown__items ${ storeForm.userInput ? 'dropdown__items--open' : false }` }>
                                {
                                    storeForm.users?.length
                                        ? storeForm.users.map(elem => {
                                            return (
                                                <div className="dropdown__item" key={ elem.id }
                                                     onClick={ () => {
                                                         dispatch(storeFormAction({
                                                             ...storeForm,
                                                             user: elem,
                                                             userInput: ''
                                                         }));
                                                     } }
                                                >{ `${ elem.name } ${ elem.phone }` }</div>
                                            );
                                        })
                                        : <div className="dropdown__item"
                                               onClick={ () => {
                                                   // Переходим на страницу с посетителями
                                                   history.push('/fitness/users');
                                                   // Закрываем форму добавления абонемента
                                                   dispatch(storeFormAction({
                                                       ...storeForm,
                                                       open: false
                                                   }));
                                                   // Открываем форму добавления посетителя
                                                   dispatch(userFormAction({
                                                       ...USER_FORM_INITIAL,
                                                       open: true,
                                                       title: 'Новый посетитель'
                                                   }));
                                               } }
                                        >{ `Добавить посетителя` }</div>
                                }
                            </div>
                        </div>
                        <div className="user__statistic" style={{ marginLeft: 14, marginTop: 3 }}>{ `Сумма: ${
                            storeForm?.user?.sum || 0
                        }, Абон: ${
                            storeForm?.user?.subscriptions || 0
                        }, Деп: ${ storeForm.user?.deposits || 0 }` }</div>
                    </div>
                    <Payment
                        payment={ storeForm.payment }
                        totalSum={ storeForm.total_sum }
                        discountValue={ storeForm.discount }
                        handler={ ({ payment, discount, total_sum }) => dispatch(storeFormAction({
                            ...storeForm,
                            payment,
                            discount,
                            total_sum
                        })) }
                    />
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                let formattedPayments = [];
                                // Фильтруем и форматируем платежи
                                storeForm.payment.forEach(el => {
                                    if (el.cost) {
                                        formattedPayments.push({ cost: el.cost, payment_method: el.payment_method.id });
                                    }
                                });

                                dispatch(saveGoodsPurchaseSagaAction({
                                    user: storeForm.user.id,
                                    goods_id: storeForm.goods_id,
                                    payment: JSON.stringify(formattedPayments),
                                    discount: storeForm.discount.id,
                                    amount: storeForm.amount
                                }));
                            } }
                        >Оформить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StoreForm;